/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetItemParams,
  Item,
  ItemInput,
  ItemMoveInput,
  RemixParams,
  RemixSyncParams,
  SchemaValidationErrorResponse,
  ToggleTemplateItemParams,
  UpdateItemParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Update Item
 */
export const updateItem = (
    itemInput: MaybeRefOrGetter<ItemInput>,
    params: MaybeRefOrGetter<UpdateItemParams>,
 signal?: AbortSignal
) => {
      itemInput = toValue(itemInput);
params = toValue(params);

      return axiosClient<Item>(
      {url: `/items`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: itemInput,
        params, signal
    },
      );
    }




export const getUpdateItemMutationKey = () => ['updateItem'] as const;

export const getUpdateItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext> => {

const mutationKey = getUpdateItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItem>>, UpdateItemMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  updateItem(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateItem>>>
    export type UpdateItemMutationBody = ItemInput
    export type UpdateItemMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateItemMutationVariables = {data: ItemInput;params: UpdateItemParams}

    /**
 * @summary Update Item
 */
export const useUpdateItem = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateItem>>,
        TError,
        UpdateItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Item
 */
export const moveItem = (
    itemMoveInput: MaybeRefOrGetter<ItemMoveInput>,
 signal?: AbortSignal
) => {
      itemMoveInput = toValue(itemMoveInput);

      return axiosClient<void>(
      {url: `/items/move`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: itemMoveInput, signal
    },
      );
    }




export const getMoveItemMutationKey = () => ['moveItem'] as const;

export const getMoveItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,MoveItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,MoveItemMutationVariables, TContext> => {

const mutationKey = getMoveItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveItem>>, MoveItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  moveItem(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveItemMutationResult = NonNullable<Awaited<ReturnType<typeof moveItem>>>
    export type MoveItemMutationBody = ItemMoveInput
    export type MoveItemMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MoveItemMutationVariables = {data: ItemMoveInput}

    /**
 * @summary Move Item
 */
export const useMoveItem = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,MoveItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveItem>>,
        TError,
        MoveItemMutationVariables,
        TContext
      > => {
      return useMutation(getMoveItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Remix Item
 */
export const remix = (
    params: MaybeRefOrGetter<RemixParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<void>(
      {url: `/items/remix`, method: 'PUT',
        params, signal
    },
      );
    }




export const getRemixMutationKey = () => ['remix'] as const;

export const getRemixMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,RemixMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,RemixMutationVariables, TContext> => {

const mutationKey = getRemixMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remix>>, RemixMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  remix(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemixMutationResult = NonNullable<Awaited<ReturnType<typeof remix>>>

    export type RemixMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RemixMutationVariables = {params: RemixParams}

    /**
 * @summary Remix Item
 */
export const useRemix = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,RemixMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof remix>>,
        TError,
        RemixMutationVariables,
        TContext
      > => {
      return useMutation(getRemixMutationOptions(options), queryClient);
    }
    /**
 * @summary Remix Item Sync
 */
export const remixSync = (
    params: MaybeRefOrGetter<RemixSyncParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Item>(
      {url: `/items/remix_sync`, method: 'PUT',
        params, signal
    },
      );
    }




export const getRemixSyncMutationKey = () => ['remixSync'] as const;

export const getRemixSyncMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,RemixSyncMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,RemixSyncMutationVariables, TContext> => {

const mutationKey = getRemixSyncMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remixSync>>, RemixSyncMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  remixSync(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemixSyncMutationResult = NonNullable<Awaited<ReturnType<typeof remixSync>>>

    export type RemixSyncMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RemixSyncMutationVariables = {params: RemixSyncParams}

    /**
 * @summary Remix Item Sync
 */
export const useRemixSync = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,RemixSyncMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof remixSync>>,
        TError,
        RemixSyncMutationVariables,
        TContext
      > => {
      return useMutation(getRemixSyncMutationOptions(options), queryClient);
    }
    /**
 * @summary Toggle Template Flag
 */
export const toggleTemplateItem = (
    params: MaybeRefOrGetter<ToggleTemplateItemParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<void>(
      {url: `/items/toggle_template`, method: 'PUT',
        params, signal
    },
      );
    }




export const getToggleTemplateItemMutationKey = () => ['toggleTemplateItem'] as const;

export const getToggleTemplateItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,ToggleTemplateItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,ToggleTemplateItemMutationVariables, TContext> => {

const mutationKey = getToggleTemplateItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleTemplateItem>>, ToggleTemplateItemMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  toggleTemplateItem(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleTemplateItemMutationResult = NonNullable<Awaited<ReturnType<typeof toggleTemplateItem>>>

    export type ToggleTemplateItemMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type ToggleTemplateItemMutationVariables = {params: ToggleTemplateItemParams}

    /**
 * @summary Toggle Template Flag
 */
export const useToggleTemplateItem = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,ToggleTemplateItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleTemplateItem>>,
        TError,
        ToggleTemplateItemMutationVariables,
        TContext
      > => {
      return useMutation(getToggleTemplateItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Item Details
 */
export const getItem = (
    id: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<GetItemParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Item>(
      {url: `/items/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetItemQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetItemParams>,) => {
    return [
    'items',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetItemQueryOptions = <TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<GetItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetItemQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItem>>> = ({ signal }) => getItem(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>
}

export type GetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getItem>>>
export type GetItemQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Item Details
 */

export function useGetItem<TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<GetItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetItemQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






